import React from 'react';
import { MediaGallery } from '../platformui';
import * as Render from '../platformui/Base/Render';

const SlideshowBlock = (props) => (
  <MediaGallery
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    Media={props.MainContent}
    Dir="ltr"
    NumOfImages={props.MainContent ? props.MainContent.length : 0}
    IllustratorTop={true}
    ShowPagination={false}
  />
);

export default SlideshowBlock;
